// src/pages/HomePage.js
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer'; // ADD THIS IMPORT

function HomePage() {
  return (
    <div>
      <Navbar />
      <div className="container">
        <h2>Welcome to the EduLinker Dashboard</h2>
        <p>Choose what you'd like to do:</p>
        {/* Conditional Content Based on User Type */}
        {/* This can be dynamically loaded based on user roles */}
        <div className="row">
          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Teacher Dashboard</h5>
                <p>Manage your lessons, schedule, and more!</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Student Dashboard</h5>
                <p>Access study materials and AI-driven plans!</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Parent Dashboard</h5>
                <p>Track your child's progress and hire tutors!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer /> 
    </div>
  );
}

export default HomePage;